
let rebuyCounter = 0;
function isRebuyWidgetLoaded() {
  const rebuyWidget = document.querySelector('#rebuy-widget-93570 .rebuy-product-title');
  const rebuyPriceSpan = document.querySelector('#rebuy-widget-93570 .rebuy-money');
  const selectElement = document.querySelector('#rebuy-widget-93570 .rebuy-select');
  
  if (rebuyWidget && rebuyPriceSpan && selectElement) {
    clearInterval(checkInterval);
    const priceElement = document.querySelector('#rebuy-widget-93570 .rebuy-product-price');
    const variantPicker = document.createElement('div');
    variantPicker.classList.add('variantPicker');

    const buttonsHTML = `
      <div class="circle-button-box active">
        <button class="circle-button black-button active" title="Blush"></button>
      </div>
      <div class="circle-button-box">
        <button class="circle-button white-button" title="Sand"></button>
      </div>
    `;
    variantPicker.insertAdjacentHTML('beforeend', buttonsHTML);

    const subtitleHTML = '<span class="rebuyWidgetSubtitle">Rączka + 2 ostrza</span>';
    rebuyWidget.insertAdjacentHTML('beforeend', subtitleHTML);

    const onetimeLabelHTML = '<span class="rebuyPriceOnetimeLabel">JEDNORAZOWY</span>';
    rebuyPriceSpan.insertAdjacentHTML('beforeend', onetimeLabelHTML);

    priceElement.parentNode.insertBefore(variantPicker, priceElement.nextSibling);

    const buttons = variantPicker.querySelectorAll('button');
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        buttons.forEach(btn => {
          btn.classList.remove('active');
          btn.parentNode.classList.remove('active');
        });
        this.classList.add('active');
        this.parentNode.classList.add('active');

        if (this.classList.contains('black-button')) {
          selectElement.value = selectElement.options[0].value;
        } else if (this.classList.contains('white-button')) {
          selectElement.value = selectElement.options[1].value;
        }

        selectElement.dispatchEvent(new Event('change'));
      });
    });
  } else {
    rebuyCounter++

    if(rebuyCounter >= 5) {
      clearInterval(checkInterval)
    }
  }
};

const checkInterval = setInterval(isRebuyWidgetLoaded, 1000); 



let rebuyCounter2 = 0;
function isRebuyWidgetLoaded95898() {
  const selectVariantElement = document.querySelector('#rebuy-widget-95898 .rebuy-product-options .rebuy-select');
  
  if (selectVariantElement) {
    clearInterval(checkInterval95898);
    const priceElement = document.querySelector('#rebuy-widget-95898 .rebuy-product-price');
    const variantPicker = document.createElement('div');
    variantPicker.classList.add('variantPicker');

    const selectElement = document.querySelector('#rebuy-widget-95898 .rebuy-product-actions .rebuy-select');
    const options = selectElement.querySelectorAll('option');
    
    options.forEach(option => {
      const value = option.value;
      const text = option.textContent;
    
      let translatedText;
      switch (value) {
        case '1':
          translatedText = '1 miesiąc';
          break;
        case '2':
          translatedText = '2 miesiące';
          break;
        case '3':
          translatedText = '3 miesiące';
          break;
        case '4':
          translatedText = '4 miesiące';
          break;
        case '5':
          translatedText = '5 miesięcy';
          break;
        case '6':
          translatedText = '6 miesięcy';
          break;
        default:
          translatedText = text;
          break;
      }
      option.textContent = translatedText;
    });

    const buttonsHTML = `
      <div class="circle-button-box active">
        <button class="circle-button black-button active" title="Blush"></button>
      </div>
      <div class="circle-button-box">
        <button class="circle-button white-button" title="Sand"></button>
      </div>
    `;
    variantPicker.insertAdjacentHTML('beforeend', buttonsHTML);

    priceElement.parentNode.insertBefore(variantPicker, priceElement.nextSibling);

    const buttons = variantPicker.querySelectorAll('button');
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        buttons.forEach(btn => {
          btn.classList.remove('active');
          btn.parentNode.classList.remove('active');
        });
        this.classList.add('active');
        this.parentNode.classList.add('active');

        if (this.classList.contains('black-button')) {
          selectVariantElement.value = selectVariantElement.options[0].value;
        } else if (this.classList.contains('white-button')) {
          selectVariantElement.value = selectVariantElement.options[1].value;
        }

        selectVariantElement.dispatchEvent(new Event('change'));
      });
    });
  } else {
    rebuyCounter2++

    if(rebuyCounter2 >= 5) {
      clearInterval(checkInterval)
    }
  }
};

const checkInterval95898 = setInterval(isRebuyWidgetLoaded95898, 1000); 
